import { InjectionKey } from "vue";
import { FormResponseState } from "./useFormResponse";

export const formResponseInjectKey =
  Symbol() as InjectionKey<FormResponseState>;
